import { ReactNode } from "react";
import SnapSectionsContainer from "@/app/features/shared/snap-section/SnapSectionsContainer";
import Section from "@/app/features/shared/snap-section/Section";
import { Box, Divider } from "@mui/material";

export function PhotoArchiveRootFrame({ children }: { children: ReactNode }) {
    return (
        <SnapSectionsContainer>
            {children}
        </SnapSectionsContainer>
    );
}

export function PhotoArchiveDetailFrame({
    children,
    showDivider,
}: {
    children: ReactNode;
    showDivider: boolean;
}) {
    return (
        <>
            {showDivider && (
                <Box sx={{ py: 4, px: '5%' }}>
                    <Divider />
                </Box>
            )}
            <Section>
                {children}
            </Section>
        </>
    );
}

export function PhotoArchiveShowroomFrame({ children }: { children: ReactNode }) {
    return (
        <Section contentHeight="fit-content">
            {children}
        </Section>
    );
}
